import React, { useContext } from "react";
import AuthContext from "../../services/firebase/auth-context/provider";
import * as styles from "./subscription-badge.module.css";
import { articleVisibilityIsPlus, hasAccessToArticle } from "../../util/subscription/access";
import DOMWindow from "../../util/dom-wrapper/window";
export let SubscriptionBadgeSize = /*#__PURE__*/ function (SubscriptionBadgeSize) {
    SubscriptionBadgeSize["BOX"] = "box";
    SubscriptionBadgeSize["DETAIL"] = "detail";
    SubscriptionBadgeSize["SIDEBAR"] = "sidebar";
    return SubscriptionBadgeSize;
}({});
const SubscriptionBadge = _ref => {
    let { size, visibility, articleId, isEdition = true, white = false, whiteIfSmallerMd = false, containerClasses = "" } = _ref;
    const { authenticated, user, userClaims } = useContext(AuthContext)[0];
    // User has access to the article.
    if (hasAccessToArticle(userClaims, authenticated, visibility, articleId, user === null || user === void 0 ? void 0 : user.email)) {
        return null;
        // User doesn't have access to the article.
    }
    else {
        return /*#__PURE__*/ React.createElement("div", {
            className: `${evaluateStyle(size)} ${containerClasses}`,
            title: evaluateTooltip(visibility)
        }, articleVisibilityIsPlus(visibility) ? MsIcon("plus", white, whiteIfSmallerMd, isEdition) : MsIcon("normal", white, whiteIfSmallerMd, isEdition));
    }
};
export default SubscriptionBadge;
const evaluateStyle = size => {
    switch (size) {
        case SubscriptionBadgeSize.BOX:
            return styles.mIconBox;
        case SubscriptionBadgeSize.DETAIL:
            return styles.mIconDetail;
        case SubscriptionBadgeSize.SIDEBAR:
            return styles.mIconSidebar;
    }
};
const evaluateTooltip = visibility => {
    if (articleVisibilityIsPlus(visibility)) {
        return "Nur mit Abo+ verfügbar";
    }
    return "Nur für Abonnenten verfügbar";
};
const MsIcon = (type, white, whiteIfSmallerMd, isEdition) => {
    const w = white ? white : whiteIfSmallerMd && DOMWindow.innerWidth() < 768;
    const baseColor = isEdition ? "#ff5b00" : "#005C16";
    const fillColor = w ? "#ffffff" : baseColor;
    const textColor = w ? baseColor : "#ffffff";
    if (type === "plus") {
        return MsIconPlus(fillColor, textColor);
    }
    return MsIconNormal(fillColor, textColor);
};
const MsIconNormal = (fillColor, textColor) => /*#__PURE__*/ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 95 95",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    strokeMiterlimit: "2"
}, /*#__PURE__*/ React.createElement("path", {
    d: "M95-.001H0c0 52.469 42.531 95 95 95v-95z",
    fill: fillColor
}), /*#__PURE__*/ React.createElement("path", {
    d: "M73.447 19.906v35.94h3.499v-41.04h-4.804L56.189 52.109 40.236 14.806h-4.982v41.04h3.321v-35.94l15.657 35.94h3.677l15.538-35.94z",
    fill: textColor
}));
const MsIconPlus = (fillColor, textColor) => /*#__PURE__*/ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 95 95",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    strokeMiterlimit: "2"
}, /*#__PURE__*/ React.createElement("path", {
    d: "M94.917-.001H-.001c0 52.469 42.497 95 94.919 95v-95z",
    fill: fillColor
}), /*#__PURE__*/ React.createElement("g", {
    fill: textColor
}, /*#__PURE__*/ React.createElement("path", {
    d: "M67.164 19.906v35.94h3.496v-41.04h-4.8l-15.94 37.304-15.94-37.304h-4.977v41.04h3.318v-35.94l15.643 35.94h3.674l15.525-35.94z"
}), /*#__PURE__*/ React.createElement("path", {
    d: "M70.408 28.738h10.725V39.71h3.2V28.738h10.666v-2.906H84.333V14.861h-3.2v10.972H70.408v2.906z"
})));
